import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SUCCESS_SAVE } from '../../../constant/Common/Message/success';
import { ALERT_MODAL_STATUS } from '../../../constant/Common/Modal/Alert/status';
import postFlip from '../../../service/DailyInOut/Post/postFlip';
import updateButtonDisabled from '../../../util/Common/Controller/Handler/updateButtonDisabled';
import useControlToast from '../../Common/Toast/useControlToast';
import dailyInOutKeys from '../keys';

const usePostFlipMutation = ({
  setIsMessageOpen,
  setMessage,
  setMessageStatus,
  setIsFlipModalOpen,
  setSelectedYard,
  div,
  fromDate,
  toDate,
  yard,
  equipmentType,
  equipment,
}) => {
  const queryClient = useQueryClient();
  const { addToast } = useControlToast();

  return useMutation({
    mutationFn: postFlip,
    onSettled: (data, error, variables) => {
      if (variables?.buttonRef)
        updateButtonDisabled({ ref: variables.buttonRef, disabled: false });
    },
    onSuccess: () => {
      setIsFlipModalOpen(false);
      setSelectedYard(null);
      queryClient.refetchQueries({
        queryKey: dailyInOutKeys?.list({
          div,
          fromDate,
          toDate,
          yard,
          equipmentType,
          equipment,
        }),
      });
      addToast?.({ message: SUCCESS_SAVE });
    },
    onError: error => {
      setMessageStatus(ALERT_MODAL_STATUS?.ERROR);
      setMessage(error.message);
      setIsMessageOpen(true);
    },
  });
};

export default usePostFlipMutation;
